module.exports = __webpack_public_path__ + "static/media/iphone-mockup.57e7f7fb.jpg";